export async function obterNomePerfilPorId (id, http) {
  try {
    const response = await http.get('/painel/backoffice/perfis-administrativos')
    const perfis = response.data
    const perfilEncontrado = perfis.find(perfil => perfil.id_perfil === id)
    return perfilEncontrado ? perfilEncontrado.nome : null
  } catch (error) {
    return null
  }
}
